<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isActive"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <div class="flex items-center">
        <img width="40" :src="ProductIcon" class="mr-4" />
        <div>
          <h4>Desired stock</h4>
          <small v-if="product">{{ product.displayName }}</small>
        </div>
      </div>
      <feather-icon
        icon="XIcon"
        @click.stop="isActive = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <Loading v-if="isLoading" />
      <div v-else class="p-6">
        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Number</span>
          </div>
          <div>
            <p>{{ product.stockProductId.id }}</p>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Name</span>
          </div>
          <div>
            <p>{{ product.displayName }}</p>
          </div>
        </div>

        <vs-row>
          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="text-sm">
              <span>Minimum amount</span>
            </div>
            <div>
              <div class="flex">
                <vs-input-number
                  v-model="product.venue.minimumAmount"
                  :min="0"
                  :step="1"
                />
              </div>
            </div>
          </vs-col>

          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="text-sm">
              <span>Desired amount</span>
            </div>
            <div>
              <div class="flex">
                <vs-input-number
                  v-model="product.venue.desiredAmount"
                  :min="0"
                  :step="1"
                />
              </div>
            </div>
          </vs-col>
        </vs-row>

        <!-- Pricing </vs-divider> -->

        <!--  
 -->
        <vs-divider class="mt-6" />
        <p>Desired stock at locations</p>

        <div
          v-for="stock in product.stocks"
          :key="stock.stockId.id"
          class="flex flex-col mb-3 mt-2"
        >
          <div class="mb-1 text-sm">
            <span>{{ stock.name }}</span>
          </div>
          <div class="flex">
            <vs-input-number v-model="stock.desiredAmount" :min="0" :step="1" />
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <feather-icon
      v-if="!isFormValid"
        icon="AlertTriangleIcon"
        svgClasses="text-danger"
      ></feather-icon>
      <span v-if="!isFormValid" class="mb-2 color-red"
        >Stock at locations must equal desired venue stock.</span
      >
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{
        "Submit"
      }}</vs-button>
      <vs-button type="border" color="danger" @click="isActive = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/product-icon.png";
import { mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      product: null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenueId: "venues/activeVenueId",
    }),
    isFormValid() {
      if (!this.product || !this.product.venue) return false;
      const desired = this.product.venue.desiredAmount;
      const locationSum = this.product.stocks.reduce(
        (sum, stock) => sum + stock.desiredAmount,
        0
      );
      return parseInt(desired) === parseInt(locationSum);
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    async show(desiredStock) {
      this.isActive = true;
      this.product = JSON.parse(JSON.stringify(desiredStock));
      this.isLoading = false;
    },

    async submitData() {
      const dto = {
        desiredAmounts: [
          {
            stockProductId: this.product.stockProductId.id,
            venueMinimumAmount: this.product.venue.minimumAmount,
            venueDesiredAmount: this.product.venue.desiredAmount,
            locationStocks: this.product.stocks.map((s) => {
              return {
                stockId: s.stockId.id,
                desiredAmount: s.desiredAmount,
              };
            }),
          },
        ],
      };

      const venueId = this.activeVenueId;

      await this.$store.dispatch("pimVenues/submitDesiredVenueStock", {
        venueId,
        dto,
      });

      this.$vs.notify({
        title: "Success",
        text: "Desired stock has been submitted",
      });

      this.product = null;
      this.isActive = false;
      this.isLoading = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>